import ConfirmationModal from 'components/modals/confirmation/ConfirmationModal';
import { useModal } from 'components/modals/useModal';
import { useDeleteExperienceRecordMutation } from 'store/api/experience-records.ts';
import { t } from 'utils/getTranslations';
import { logError } from 'utils/monitoring';
import { useLeaveDeletedEntity } from 'utils/useNavigateWithReturnState.ts';

/**
 * Delete, for the edit form and the record header: asks first, then leaves the record's pages.
 * `beforeLeave` runs once the record is gone, such as lifting the form's leave guard.
 */
export const useExperienceRecordDelete = (xrId: string | undefined, beforeLeave?: () => void) => {
    const { openModal, closeModal } = useModal();
    const leaveDeleted = useLeaveDeletedEntity('/experience-records');
    const [deleteExperienceRecord] = useDeleteExperienceRecordMutation();

    return () => {
        if (xrId && !isNaN(Number(xrId))) {
            openModal(
                <ConfirmationModal
                    onCancel={closeModal}
                    onConfirm={() => {
                        void (async () => {
                            try {
                                await deleteExperienceRecord({ id: xrId }).unwrap();
                                closeModal();
                                beforeLeave?.();
                                leaveDeleted();
                            } catch (e) {
                                logError(e);
                            }
                        })();
                    }}
                    content={<p className="text-body1">{t('experience-records.delete-confirmation-text')}</p>}
                />
            );
        }
    };
};
